import { PaginationFilter } from '@liveauctioneers/caterwaul-components/types/PaginationFilter';
import { FormattedMessage, FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { Select } from '@liveauctioneers/hammer-ui-core/select';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { Component } from 'react';
import isEqual from 'react-fast-compare';

import CategoryAd from '@/components/Ads/CategoryAd';
import PageTitle from '@/components/PageTitle/PageTitle';
import Pagination from '@/components/Pagination/hammer-pagination/Pagination';
import { WonItemsCard } from '@/pages/WonItems/components/WonItemsCard/WonItemsCard';
import { LeaderBoardAdTypes } from '@/redux/modules/catalog/ad/catalogAd.types';
import { WonCatalog } from '@/types/WonCatalog';

import EOARemovalResponseAction from './EOARemovalResponseAction';
import WonItemsPageHeaderMeta from './WonItemsPageHeaderMeta';

const VIEWS_TO_SHOW = [10, 25, 50, 100];

type Props = {
    bidderIsSuspended: boolean;
    filter: string;
    filterOptions: any[];
    handleFilterChange: (event: { value: string }) => void;
    onPageChange: Function;
    reviews: any[];
    wonCatalogs: WonCatalog[];
    wonItemsViewData: PaginationFilter;
};

type State = {
    addCatalogItems: any;
};

export class WonItemsPage extends Component<Props, State> {
    state = {
        addCatalogItems: [],
    };

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    mapWonCatalogs = (wonCatalog: WonCatalog) => {
        const { reviews } = this.props;

        const reviewed = Boolean(reviews.find((review) => review.catID === wonCatalog.catalogId && review.reviewed));

        return (
            <WonItemsCard
                isBidderSuspended={this.props.bidderIsSuspended}
                key={wonCatalog.catalogId}
                reviewed={reviewed}
                wonCatalog={wonCatalog}
            />
        );
    };

    render() {
        const { filter, filterOptions, handleFilterChange, onPageChange, wonCatalogs, wonItemsViewData } = this.props;

        const adId = 'won-items';
        const adPageName = `leaderboard-${adId}`;

        return (
            <>
                <CategoryAd
                    adType={LeaderBoardAdTypes[adId]}
                    pageName={adPageName}
                />
                <div className="relative mx-auto mb-xl mt-0 min-h-[400px] max-w-[1240px] px-md py-0">
                    <WonItemsPageHeaderMeta />
                    <EOARemovalResponseAction />
                    <PageTitle title={<FormattedMessage id="won_items" />} />
                    <Pagination
                        filter={
                            <div className="mb-sm flex justify-between">
                                <h5 data-testid="orderCount">
                                    <FormattedMessage
                                        id="wonitems.orderCount"
                                        values={{
                                            formattedNumber: (
                                                <FormattedNumber
                                                    key="formatted_number"
                                                    value={wonItemsViewData.totalRecords || 0}
                                                />
                                            ),
                                            totalOrders: wonItemsViewData.totalRecords || 0,
                                        }}
                                    />
                                </h5>
                                <Select
                                    className="w-[230px]"
                                    isInsideLabel
                                    labelText={
                                        <>
                                            <FormattedMessage id="dispute_status" />:
                                        </>
                                    }
                                    onChange={handleFilterChange}
                                    options={filterOptions}
                                    placeholder={<FormattedMessage id="select" />}
                                    small
                                    value={filterOptions.find((op) => op.value === filter)}
                                />
                            </div>
                        }
                        onChange={onPageChange}
                        pageSizeOptions={VIEWS_TO_SHOW}
                        paginationFilter={wonItemsViewData}
                        shouldModifyQueryParams
                    >
                        {wonCatalogs.length !== 0 && wonCatalogs.map(this.mapWonCatalogs)}

                        {!wonCatalogs.length && (
                            <div className="flex flex-row justify-center p-xl">
                                <BodyPrimary>
                                    {filter === 'ALL' ? (
                                        <FormattedMessage id="no_won_items" />
                                    ) : (
                                        <FormattedMessage id="no_disputes" />
                                    )}
                                </BodyPrimary>
                            </div>
                        )}
                    </Pagination>
                </div>
            </>
        );
    }
}
